<template>
  <header class="subnav subnav-filters">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="navbar-group">
        <!-- 
					<input type="checkbox" class="btn-check" id="conferenceGroupChecked" autocomplete="off" v-model="conferenceGroupChecked">
					<label class="btn btn-toggle" for="conferenceGroupChecked">Group by conference</label>

					{{conferenceGroupChecked}} -->

        <ul class="nav nav-pills" id="pills-tab" role="tablist" data-v-step="1">
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-sm nav-link caps"
              id="pills-agenda-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-agenda"
              type="button"
              role="tab"
              aria-controls="pills-agenda"
              aria-selected="true"
            >
              <span>{{ $i18n.t('message.SubNavbar.meeting') }}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="btn btn-sm nav-link caps active"
              id="pills-conference-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-conference"
              type="button"
              role="tab"
              aria-controls="pills-conference"
              aria-selected="false"
            >
              <span>{{ $i18n.t('message.SubNavbar.event') }}</span>
            </button>
          </li>
        </ul>
      </div>
      <div class="navbar-group actions">
        <button type="button" @click="print" data-v-step="0">
          <i class="bi-printer"></i>
          <span>{{ $i18n.t('message.SubNavbar.print') }}</span>
        </button>
        <button type="button" @click="email">
          <i class="bi-envelope"></i>
          <span>{{ $i18n.t('message.SubNavbar.email') }}</span>
        </button>
        <button type="button" @click="exportCalendar">
          <i class="bi-file-earmark-spreadsheet"></i>
          <span>{{ $i18n.t('message.SubNavbar.export') }}</span>
        </button>
      </div>
    </div>
  </header>
</template>
<script setup>
import { useRouter, useRoute } from "vue-router";
import { useAlertsStore } from "@/stores/alerts";
import { useAgendaStore } from "@/stores/parent/agenda";
const router = useRouter();
const route = useRoute();
const alertStore = useAlertsStore();
const agendaStore = useAgendaStore();
function print() {
  let routeData = router.resolve({
    name: "parent-print",
    params: { account: route.params.account }
  });
  window.open(routeData.href, "_blank");
}
async function email() {
  try {
    const resp = await agendaStore.getEmail();
    if (resp?.status === true) {
      alertStore.addAlert("success", "Email has been sent with your schedule");
    } else {
      alertStore.addAlert("error", "Failed to send email to recipient");
    }
  } catch (error) {
    alertStore.addAlert("error", "Failed to send email to recipient");
  }
}

async function exportCalendar() {
  let resp = await agendaStore.exportCalendar();
  downloadString(resp.ics, "application/ics", "invite.ics");
}
function downloadString(text, fileType, fileName) {
  var blob = new Blob([text], { type: fileType });

  var a = document.createElement("a");
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function () {
    URL.revokeObjectURL(a.href);
  }, 1500);
}
</script>
